import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { VirtualScrollerComponent } from '@iharbeck/ngx-virtual-scroller';

import { Idea } from '../../../models/Sessions/Idea/Idea';
import { Session } from '../../../models/Sessions/Session';
import { BusService } from '../../../services/bus.service';
import { EventsService } from '../../../services/events.service';

@Component({
  selector: 'app-filtered-idea-list',
  templateUrl: './filtered-idea-list.component.html',
  styleUrls: ['./filtered-idea-list.component.scss'],
})
export class FilteredIdeaListComponent implements OnInit {
  @Input() ideas: Idea[] = [];
  @Input() ideaIdToSession: object = {};

  @ViewChild(VirtualScrollerComponent) scroll: VirtualScrollerComponent;
  @ViewChild('divParent', { static: true }) divParent: ElementRef;

  height;
  width;

  constructor(
    private bus: BusService,
    private events: EventsService,
  ) {}

  @HostListener('window:resize', ['$event'])
  afterResize() {
    this.height = this.divParent.nativeElement.offsetHeight + 'px';
    this.width = this.divParent.nativeElement.offsetWidth + 'px';
    this.scroll.refresh();
  }

  openIdea(idea: Idea, session: Session) {
    this.bus.publish(
      this.events.requested.data.session.idea.singleWithSession,
      idea._id,
      session._id,
    );
  }

  ngOnInit() {
    this.height = this.divParent.nativeElement.offsetHeight + 'px';
    this.width = this.divParent.nativeElement.offsetWidth + 'px';
  }

  getSessionForIdea(idea: Idea) {
    if (this.ideaIdToSession) {
      return this.ideaIdToSession[idea._id];
    } else {
      return null;
    }
  }
}
